export default "__VITE_ASSET__BQWGCglZ__"